import {BaseCommandMessage, BaseResponseMessage} from "../commands"

export namespace Payments {
    export const COMMAND_CREATE_INVOICE = 'command_create_invoice'
    export const COMMAND_DEPOSIT_MONEY = 'command_deposit_money' // пополнение баланса
    export const COMMAND_TRANSACTIONS = 'command_transactions'

    export class CreateInvoiceCommand extends BaseCommandMessage {
        /**
         *
         * @param cents сумма в копейках, например 3$ это 300
         */
        constructor(readonly cents: number) {
            super(COMMAND_CREATE_INVOICE)
        }
    }

    export class CreateInvoiceCommandResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly invoiceUrl: string) {
            super(COMMAND_CREATE_INVOICE, id, true)
        }
    }

    export class DepositMoneyResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly depositOn: number, readonly money: number) {
            super(COMMAND_DEPOSIT_MONEY, id, true)
        }
    }

    export class TransactionsCommand extends BaseCommandMessage {
        constructor(readonly start: number, readonly limit: number) {
            super(COMMAND_TRANSACTIONS)
        }
    }

    export class TransactionsCommandResponse extends BaseResponseMessage {
        constructor(override readonly id: number, readonly transactions: TransactionInfo[], readonly total: number) {
            super(COMMAND_TRANSACTIONS, id, true)
        }
    }

    export class TransactionInfo {
        readonly id: string
        readonly date: number
        readonly amount: number
        readonly description: string
    }
}